import { render } from "./XLoadingIcon.vue?vue&type=template&id=577a1b8f&scoped=true"
const script = {}

import "./XLoadingIcon.vue?vue&type=style&index=0&id=577a1b8f&lang=scss"
import "./XLoadingIcon.vue?vue&type=style&index=1&id=577a1b8f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577a1b8f"]])

export default __exports__